export type { YardAreaDetails } from './yardAreaPresenterV2Shared';

export { useYardAreaFetcherV2 } from './useYardAreaFetcherV2';
export type { UseYardAreaFetcherV2Options } from './useYardAreaFetcherV2';
export type { UseYardAreaFetcherV2Options as UseYardAreaPresenterV2Options } from './useYardAreaFetcherV2';

export { useYardAreaDisplayV2 } from './useYardAreaDisplayV2';
export type {
  YardAreaDisplayField,
  YardAreaDisplayV2Data,
  UseYardAreaDisplayV2Options
} from './useYardAreaDisplayV2';

import { useYardAreaFetcherV2 } from './useYardAreaFetcherV2';

import type { UseYardAreaFetcherV2Options } from './useYardAreaFetcherV2';

/**
 * Combined fetch + live-update composable. Delegates to {@link useYardAreaFetcherV2}.
 * Pair with {@link useYardAreaDisplayV2} when fetch is owned by a parent (e.g. list row).
 */
export function useYardAreaPresenterV2(options: UseYardAreaFetcherV2Options) {
  return useYardAreaFetcherV2(options);
}
